/* AI Shop Assistant — docking.
   Keeps the launcher tidy next to other floating buttons (WhatsApp, back-to-top,
   live chat). Those are injected by apps at runtime, so nothing about them can be
   known in advance: this measures whatever is actually pinned in the same corner,
   lines the two up on one centre line, and stacks them without overlapping. */
(function () {
  var root = document.getElementById('ai_shop_assistant');
  if (!root || root.dataset.docked) return;
  root.dataset.docked = '1';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('aisa-config').textContent); } catch (e) {}
  var launcher = root.querySelector('.aisa-launcher');

  var FLOAT_SEL = 'a[href*="wa.me"],a[href*="api.whatsapp.com"],a[href*="web.whatsapp.com"],a[href*="whatsapp.com/send"],[class*="whatsapp"],[id*="whatsapp"],[class*="wa-chat"],[class*="wa-widget"],[class*="chat-button"],[id*="chat-button"],[class*="float-button"]';
  var GAP = 14, MAX_LIFT = 260, lifted = 0, alignedSide = null, barred = 0;

  function cornerNodes() {
    var out = [], seen = [], vh = window.innerHeight;
    function consider(n) {
      if (!n || n.nodeType !== 1 || n === root || root.contains(n)) return;
      var cs, hops = 0;
      try { cs = window.getComputedStyle(n); } catch (e) { return; }
      while (cs && cs.position !== 'fixed' && n.parentElement && hops++ < 4) {   // the fixed wrapper may be an ancestor
        n = n.parentElement;
        if (n === root || root.contains(n) || n === document.body || n === document.documentElement) return;
        try { cs = window.getComputedStyle(n); } catch (e) { return; }
      }
      if (!cs || cs.position !== 'fixed') return;
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
      if (seen.indexOf(n) !== -1) return;
      seen.push(n);
      var r = n.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.width > 220 || r.height > 220) return;      // a bar or an overlay, not a bubble
      if (vh - r.bottom > 260) return;                  // not sitting in the bottom corner
      out.push(n);
    }
    var kids = (document.body && document.body.children) || [];
    for (var i = 0; i < kids.length && i < 120; i++) consider(kids[i]);
    var named = [];
    try { named = document.querySelectorAll(FLOAT_SEL); } catch (e) {}
    for (var j = 0; j < named.length && j < 40; j++) consider(named[j]);
    return out;
  }

  /* A sticky bar pinned across the bottom — a mobile toolbar, a cookie notice,
     a sticky add-to-cart. Too wide to be a bubble, so it is stepped over
     rather than stacked with. Returns the height to stay clear of. */
  function bottomBar() {
    var vh = window.innerHeight, vw = window.innerWidth, tallest = 0;
    var kids = (document.body && document.body.children) || [];
    for (var i = 0; i < kids.length && i < 120; i++) {
      var n = kids[i];
      if (!n || n.nodeType !== 1 || n === root || root.contains(n)) continue;
      var cs;
      try { cs = window.getComputedStyle(n); } catch (e) { continue; }
      if (!cs || (cs.position !== 'fixed' && cs.position !== 'sticky')) continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      var r = n.getBoundingClientRect();
      if (r.width < vw * 0.6 || !r.height || r.height > 140) continue;   // a bar, not a panel
      if (Math.abs(vh - r.bottom) > 4) continue;                          // not pinned to the bottom
      if (r.height > tallest) tallest = r.height;
    }
    return Math.round(tallest);
  }

  function arrange() {
    if (cfg.dock === false || !launcher) return;
    if (root.dataset.open === 'true') return;           // only the closed launcher is arranged
    var mine = launcher.getBoundingClientRect();
    if (!mine.width || !mine.height) return;
    var vh = window.innerHeight, vw = window.innerWidth;
    var bar = bottomBar();
    if (bar !== barred) { barred = bar; root.style.setProperty('--aisa-bar', bar ? (bar + 8) + 'px' : '0px'); return arrange(); }
    var below = cfg.stack !== 'above';                  // default: the assistant sits underneath
    var rest = (vh - mine.bottom) - lifted;             // our resting distance from the bottom
    var lift = 0, alignTo = null;

    cornerNodes().forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (Math.min(mine.right, r.right) - Math.max(mine.left, r.left) <= 0) return;   // a different column
      if (alignTo === null) alignTo = { left: r.left, right: r.right, width: r.width };   // line the two buttons up

      if (below) {
        // Put the other button above ours by moving its own bottom offset.
        var want = Math.round((vh - mine.top) + lifted + GAP);
        if (Math.abs((vh - r.bottom) - want) > 1) {
          try {
            n.style.setProperty('bottom', want + 'px', 'important');
            n.style.setProperty('top', 'auto', 'important');
          } catch (e) {}
        }
        var after = n.getBoundingClientRect();
        if (Math.min(mine.bottom, after.bottom) - Math.max(mine.top, after.top) <= 0) return;  // clear now
        r = after;                                       // could not move it — lift ourselves instead
      }

      var need = (vh - r.top) + GAP - rest;
      if (need > lift) lift = need;
    });

    // Line up with the neighbour, so the two read as one stack even though the
    // app uses its own margins: two bubbles share a centre line, while a wide
    // button lines up on its outer edge instead.
    if (alignTo !== null) {
      var left = root.getAttribute('data-side') === 'left';
      var mid = alignTo.left + alignTo.width / 2;
      var wide = mine.width > alignTo.width * 1.4;
      var side = left
        ? Math.round(wide ? alignTo.left : mid - mine.width / 2)
        : Math.round(wide ? (vw - alignTo.right) : (vw - mid) - mine.width / 2);
      side = Math.max(6, Math.min(side, 80));
      if (side !== alignedSide) { alignedSide = side; root.style.setProperty('--aisa-gap-side', side + 'px'); }
    } else if (alignedSide !== null) {
      alignedSide = null; root.style.removeProperty('--aisa-gap-side');
    }

    lift = Math.max(0, Math.min(Math.round(lift), MAX_LIFT));
    if (lift !== lifted) { lifted = lift; root.style.setProperty('--aisa-lift', lift + 'px'); }
  }

  // Apps inject their button at their own pace, so re-measure a few times.
  [0, 600, 1500, 3500, 7000].forEach(function (ms) { setTimeout(arrange, ms); });
  window.addEventListener('resize', arrange);
  window.addEventListener('orientationchange', function () { setTimeout(arrange, 300); });
  // The panel opens and closes on its own, so watch for that here rather than
  // asking the widget to tell us.
  try {
    new MutationObserver(function () { setTimeout(arrange, 60); })
      .observe(root, { attributes: true, attributeFilter: ['data-open'] });
  } catch (e) {}
  window.AISA_DOCK = { arrange: arrange };
})();